import {useContext} from 'react';

import {Navigate, Outlet} from 'react-router-dom';

import {UserContext} from '../../contexts/UserContext/UserContext';
import {AppConfig} from '../../lib/AppConfig';

export const AccountConfirmedGuard = () => {
  const {currentUser, isLoading} = useContext(UserContext);

  if (isLoading || !currentUser) {
    return null;
  }

  return currentUser?.accountConfirmed ? <Outlet /> : <Navigate to={AppConfig.USER_CONFIRM_EMAIL_PATH} />;
};
